
<button class="sec-doc-action-buttons" style="margin: 20px 0px 0px 30px;" (click)="closeTab()">
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.3477 5.45508L8.53516 8.26758L11.3242 11.0566C11.5586 11.2676 11.5586 11.6191 11.3242 11.8301C11.1133 12.0645 10.7617 12.0645 10.5508 11.8301L7.73828 9.04102L4.94922 11.8301C4.73828 12.0645 4.38672 12.0645 4.17578 11.8301C3.94141 11.6191 3.94141 11.2676 4.17578 11.0332L6.96484 8.24414L4.17578 5.45508C3.94141 5.24414 3.94141 4.89258 4.17578 4.6582C4.38672 4.44727 4.73828 4.44727 4.97266 4.6582L7.76172 7.4707L10.5508 4.68164C10.7617 4.44727 11.1133 4.44727 11.3477 4.68164C11.5586 4.89258 11.5586 5.24414 11.3477 5.45508Z" fill="black"/>
  </svg>            
  Close
</button>
<div *ngFor="let subForm of subForms;">
  <ng-container *ngIf="subForm?.subform_name!='Review Form' && subForm?.subform_name!='Print'">
      <div *ngFor="let section of subForm.subform_sections" class="outer-container margin-10 padding-10">
          <mat-card appearance="outlined" class="paddingBottom20 mat-card-container w-900">
              <mat-card-header class="mat-card-header-container">
                  <mat-card-title class="section_header_typography">{{ section.section_name }}</mat-card-title>
              </mat-card-header>
              <mat-card-content class="mat-card-content-container">
                  <div class="mat-card-content-inner-container">
                      <div *ngFor="let field of section.fields">
                          <div class="field_header_typography">
                              {{field.field_label}}
                          </div>
                          <div *ngIf="field.control_type != 'checkbox'" class="field_value_typography">
                              <div *ngIf="field.selected_values!=null && field.selected_values!=''">
                                  {{ field.selected_values }}
                              </div>
                              <div *ngIf="field.selected_values == null || field.selected_values == ''">
                                  -
                              </div>
                          </div>
                          <div *ngIf="field.control_type == 'checkbox'">
                            <div *ngFor="let option of field.options; let i = index">
                              <div *ngFor="let selectedValue of field.selected_values; let j = index" class="field_value_typography">
                                  <ng-container *ngIf="selectedValue[i] == true">
                                      {{option.key}}
                                  </ng-container>
                              </div>
                          </div>
                          </div>
                      </div>
                  </div>
              </mat-card-content>
          </mat-card>
      </div>
  </ng-container>
</div>
<div class="outer-container margin-5 padding-5">
  <mat-card class="paddingBottom20 document-header-container">
    <mat-card-header style="padding: 0px 10px 0px 45px;">
        <span class="documents-title">Documents</span>
    </mat-card-header>
  </mat-card>
</div>
<ng-container *ngIf="documentsList && documentsList.length > 0">
  <div *ngFor="let document of documentsList;" class="outer-container margin-5 padding-5">
    <mat-card appearance="outlined" class="paddingBottom20 mat-card-document-container w-800">
        <mat-card-content style="padding: 10px 10px 10px 40px;">
            <div class="doc-wrapper">
                <div class="documentContainer">
                    <div class="document-name" [matTooltip]=" document.name.length > 50 ? document.name : ''">
                        {{ document.name }}
                    </div>
                    <div class="uploaded-by">
                        <span class="label">Uploaded By </span>
                        <span class="name">{{ document.createdBy }} </span>
                        <span class="label">{{ document.createdDate }}</span>
                    </div>
                </div>
                <div class="sec-doc-action-buttons-container">
                        <button mat-button class="sec-doc-action-buttons" (click)="viewDocument(document)">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.75 3.375C6.20312 3.375 4.96094 4.07812 4 4.96875C3.08594 5.8125 2.47656 6.79688 2.14844 7.5C2.47656 8.20312 3.08594 9.21094 4 10.0547C4.96094 10.9453 6.20312 11.625 7.75 11.625C9.27344 11.625 10.5156 10.9453 11.4766 10.0547C12.3906 9.21094 13.0234 8.20312 13.3281 7.5C13.0234 6.79688 12.3906 5.8125 11.5 4.96875C10.5156 4.07812 9.27344 3.375 7.75 3.375ZM3.22656 4.14844C4.32812 3.11719 5.85156 2.25 7.75 2.25C9.625 2.25 11.1484 3.11719 12.25 4.14844C13.3516 5.17969 14.0781 6.375 14.4297 7.21875C14.5 7.40625 14.5 7.61719 14.4297 7.80469C14.0781 8.625 13.3516 9.84375 12.25 10.875C11.1484 11.9062 9.625 12.75 7.75 12.75C5.85156 12.75 4.32812 11.9062 3.22656 10.875C2.125 9.84375 1.39844 8.625 1.04688 7.80469C0.976562 7.61719 0.976562 7.40625 1.04688 7.21875C1.39844 6.375 2.125 5.15625 3.22656 4.14844ZM7.75 9.375C8.78125 9.375 9.625 8.55469 9.625 7.5C9.625 6.46875 8.78125 5.625 7.75 5.625C7.72656 5.625 7.70312 5.625 7.70312 5.625C7.72656 5.76562 7.75 5.88281 7.75 6C7.75 6.84375 7.07031 7.5 6.25 7.5C6.10938 7.5 5.99219 7.5 5.875 7.45312C5.875 7.47656 5.875 7.5 5.875 7.5C5.875 8.55469 6.69531 9.375 7.75 9.375ZM7.75 4.5C8.80469 4.5 9.78906 5.08594 10.3281 6C10.8672 6.9375 10.8672 8.08594 10.3281 9C9.78906 9.9375 8.80469 10.5 7.75 10.5C6.67188 10.5 5.6875 9.9375 5.14844 9C4.60938 8.08594 4.60938 6.9375 5.14844 6C5.6875 5.08594 6.67188 4.5 7.75 4.5Z" fill="#333333"/>
                            </svg>
                            <span class="font-size-12" style="margin-left: 5px;">View</span>
                        </button>
                        <button mat-button class="sec-doc-action-buttons" (click)="downloadDocument(document)">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.4375 12.75H3.5625C3.23438 12.75 3 12.5156 3 12.1875C3 11.8828 3.23438 11.625 3.5625 11.625H11.4375C11.7422 11.625 12 11.8828 12 12.1875C12 12.5156 11.7422 12.75 11.4375 12.75ZM7.07812 9.58594L4.07812 6.39844C3.86719 6.16406 3.89062 5.8125 4.10156 5.60156C4.33594 5.39062 4.6875 5.39062 4.89844 5.625L6.9375 7.78125V5.8125V2.8125C6.9375 2.50781 7.17188 2.25 7.5 2.25C7.80469 2.25 8.0625 2.50781 8.0625 2.8125V5.8125V7.78125L10.0781 5.625C10.2891 5.39062 10.6406 5.39062 10.875 5.60156C11.1094 5.8125 11.1094 6.16406 10.8984 6.39844L7.89844 9.58594C7.78125 9.70312 7.64062 9.75 7.5 9.75C7.33594 9.75 7.19531 9.70312 7.07812 9.58594Z" fill="#333333"/>
                            </svg>
                            <span class="font-size-12" style="margin-left: 5px;">Download</span>
                        </button>
                    </div>
                </div>
        </mat-card-content>
    </mat-card>
  </div>
</ng-container>
<ng-container *ngIf="(!documentsList) || (documentsList && documentsList.length == 0)">
  <div class="outer-document-container">
    <mat-card appearance="outlined" class="paddingBottom20 mat-card-container W-800">
        <mat-card-content style="padding: 10px 10px 10px 40px;">
            <div class="doc-wrapper">
                <div class="documentContainer">
                    <div>
                        No Documents Found
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
  </div>
<div class="overlay" *ngIf="isLoading"></div>
<div class="d-flex justify-content-center" *ngIf="isLoading">
  <div
    class="spinner-border loading-indicator"
    role="status"
  >
    <span class="sr-only">Loading...</span>
  </div>
</div>